<template>
  <Home />
</template>

<script setup>
import Home from '@/sections/home/Home.vue';
</script>
